import { createMinorSuitCore } from '../internal/core-builders';

export const MINOR_CUPS_CORE = createMinorSuitCore('Coppe');
